/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_A6Inputs */

const en_to_csv_faq_a6 = /** @type {(inputs: To_Csv_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The output is UTF-8 without a byte order mark, and Excel on Windows falls back to the system code page when it cannot find one. Import the file through Data then From Text and select UTF-8 rather than double clicking it. Google Sheets and LibreOffice detect the encoding correctly.`)
};

const ko_to_csv_faq_a6 = /** @type {(inputs: To_Csv_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력은 바이트 순서 표시가 없는 UTF-8이고, Windows의 Excel은 그것을 찾지 못하면 시스템 코드 페이지로 물러납니다. 두 번 클릭하지 말고 데이터 다음 텍스트에서로 파일을 가져와 UTF-8을 선택하세요. Google Sheets와 LibreOffice는 인코딩을 올바르게 감지합니다.`)
};

const ja_to_csv_faq_a6 = /** @type {(inputs: To_Csv_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力はバイトオーダーマークのない UTF-8 で、Windows の Excel はそれが見つからないとシステムコードページに退きます。ダブルクリックせず、データからテキストでファイルを取り込み UTF-8 を選んでください。Google スプレッドシートと LibreOffice はエンコーディングを正しく判定します。`)
};

/**
* | output |
* | --- |
* | "The output is UTF-8 without a byte order mark, and Excel on Windows falls back to the system code page when it cannot find one. Import the file through Data ..." |
*
* @param {To_Csv_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_a6 = /** @type {((inputs?: To_Csv_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_a6(inputs)
	if (locale === "ko") return ko_to_csv_faq_a6(inputs)
	return ja_to_csv_faq_a6(inputs)
});